/**
 * Notion 28 spec の button 装飾 sx パターン.
 *
 * MUI Button の default は size="small" でも `padding: 4px 10px` で薄く、 contained は
 * box-shadow が default で乗り「ふわっ」 した印象になる. Notion は flat + 適度な padding が標準
 * (28 spec §4.3 ピル状 CTA: h 28-32 / radius 4-6 / fontSize 13 / 影なし) のため、
 * dialog 等の primary / secondary CTA はこの sx を素 MUI Button にかぶせて使う.
 *
 * 既存 atoms/Button (= nasu portage) は別系統で MeetingTabBar や ActionBar 等の
 * pill 形 CTA で使う. 本 sx は素 MUI Button (DialogActions / 単発 CTA) 向け.
 */
import { RADIUS } from './radii'

export const NOTION_BUTTON_PRIMARY_SX = {
  px: 2,
  py: 0.75,
  fontSize: 13,
  fontWeight: 500,
  borderRadius: `${RADIUS.md}px`,
  boxShadow: 'none',
  '&:hover': { boxShadow: 'none' },
} as const

export const NOTION_BUTTON_TEXT_SX = {
  color: 'text.secondary',
  px: 2,
  py: 0.75,
  fontSize: 13,
  fontWeight: 500,
} as const
